import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
import { BlockchainTransactionDto } from "healthex-common/blockchain.dtos";
import { plainToInstance } from "class-transformer";
export class BlockchainService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async resend(userId, orgId, transactionId) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/organizations/:orgId/users/:userId/transactions/:transactionId/resend", {
            orgId,
            userId,
            transactionId,
        }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(BlockchainTransactionDto, response.data);
    }
    async waitForStatusUpdate(userId, orgId, transactionId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, `/organizations/:orgId/users/:userId/transactions/:transactionId?wait=${30}`, {
            orgId,
            userId,
            transactionId,
        }), await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(BlockchainTransactionDto, response.data);
    }
}
